export const ENDPOINT_ERROR_MESSAGE_KEYS: {
  readonly errorDataDoesNotMatch: "errors.http.errorDataDoesNotMatch";
} = {
  errorDataDoesNotMatch: "errors.http.errorDataDoesNotMatch",
} as const;

export type EndpointErrorMessageKey = (typeof ENDPOINT_ERROR_MESSAGE_KEYS)[keyof typeof ENDPOINT_ERROR_MESSAGE_KEYS];

export interface EndpointErrorRule {
  pattern: string | RegExp;
  status: number;
  key: EndpointErrorMessageKey;
}

export const ENDPOINT_ERROR_RULES: ReadonlyArray<EndpointErrorRule> = [
  { pattern: "prelogin", status: 404, key: ENDPOINT_ERROR_MESSAGE_KEYS.errorDataDoesNotMatch },
];
